import script from "./ArtistArtworkSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistArtworkSearch.vue?vue&type=script&setup=true&lang=js"

import "./ArtistArtworkSearch.vue?vue&type=style&index=0&id=25110b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25110b44"]])

export default __exports__